var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdaLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1411.36 271.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#424242;}.cls-2{fill:#3299bb;stroke:#00aeef;stroke-miterlimit:10;stroke-width:2px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.6,169.52,67.4,90.32,15.8,219.12H0l59.4-146H75.8l60.8,146h-17l-14.4-35.6h-67l5.4-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M242.6,71.72v114q0,33.4-32.6,33.4H175.6q-32.6,0-32.6-33.4v-37.6q0-33.4,32.6-33.4H220v14.6H178.4q-20.8,0-20.8,21.2v32.8q0,21.4,20.8,21.4h28.8q20.8,0,20.8-21.4V71.72Zm30.75,57.2H220v-14.2h53.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M329.4,114.72q32.6,0,32.6,33.4v37.6q0,33.4-32.6,33.4H292.6q-27.8,0-27.8-27.6v-8.2q0-23.2,26.4-23.2h48.2v11.8H295q-16.2,0-16.2,13.8v4.8q0,16,16.4,16H327q20.4,0,20.4-21.2v-35.8q0-20.6-19.8-20.6H268v-14.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M468.6,114.72v12.6H409.4q-13.4,0-13.4,12.4v8.2q0,11.4,12.4,11.4h42q22.8,0,22.8,21.4v15.2q0,23.2-24.6,23.2H382.8v-12.6h62q14.2,0,14.2-12.4v-11.8q0-11.4-12.2-11.4h-42q-23,0-23-21.4v-11.8q0-23,24-23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M583.19,169.52,551,90.32l-51.6,128.8h-15.8l59.4-146h16.4l60.8,146h-17l-14.4-35.6h-67l5.4-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M649.59,71.72v147.4H635V71.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M740.19,114.72q32.6,0,32.6,33.4v71q0,35.4-32.6,35.4h-47.8v-14.2h45q20.8,0,20.8-22.8v-67q0-21.2-20.8-21.2h-28.8q-20.8,0-20.8,21.2v28.6q0,20,20.8,20h41.6v13.6h-44.4q-32.6,0-32.6-31.4v-33.2q0-33.4,32.6-33.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M863.39,114.72q32.6,0,32.6,33.4v37.6q0,33.4-32.6,33.4H828q-32.6,0-32.6-33.4v-37.6q0-33.4,32.6-33.4ZM810,183.32q0,21.4,20.8,21.4h29.8q20.8,0,20.8-21.4v-32.8q0-21.2-20.8-21.2h-29.8q-20.8,0-20.8,21.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M980.59,114.92v14.4H955q-20.6,0-20.6,21.4v68.4h-14.6v-70.8q0-33.4,32.6-33.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1013.39,115.72v103.4h-14.6V115.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1065.59,80.72v34h22.6v13h-22.6v91.4H1051v-91.4h-19.6v-13H1051v-34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1121.18,71.72v43h52.4q32.6,0,32.6,33.4v71h-14.6v-68.6q0-21.2-20.8-21.2h-49.6v89.8h-14.6V71.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1351.58,114.72q32.2,0,32.2,33.4v71h-14.6v-68.6q0-21.4-20.4-21.4h-34.6v90h-14v-90H1245v90h-14.4V114.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1005.91,54.06q9.72,0,9.72,10V87.9q0,10-9.72,10H993.73q-9.78,0-9.78-10V64q0-10,9.78-10Zm-17.4,33.12q0,6.18,6.06,6.18H1005q6.06,0,6.06-6.18V64.74q0-6.18-6.06-6.18H994.57q-6.06,0-6.06,6.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1023.67,54.06q7.8,0,7.8,7.92V97.86h-4.56v-35q0-4.26-4.2-4.26h-2.22v-4.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1088.19,
    y: 114.72,
    width: 33,
    height: 13.28
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdaLogo);
export default __webpack_public_path__ + "static/media/ada-logo.df38ec53481894175176df6f4194cab3.svg";
export { ForwardRef as ReactComponent };